import Icon from "../../../components/AppIcon";
import { AcademicHighlight } from "../types";

interface AcademicHighlightsProps {
  highlights: AcademicHighlight[];
}

const AcademicHighlights = ({ highlights }: AcademicHighlightsProps) => {
  return (
    <section className="py-20 bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-accent/10 border border-accent/20 rounded-full mb-4">
            <Icon name="GraduationCap" size={18} color="var(--color-accent)" />
            <span className="text-sm font-mono text-accent">Academic Excellence</span>
          </div>
          <h2 className="text-4xl sm:text-5xl font-bold text-foreground mb-4">
            Education &amp; Achievements
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            Building a strong foundation through rigorous academic training at Valencia College
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          {highlights.map((highlight, index) => (
            <div
              key={highlight.id}
              className="group bg-surface border border-border rounded-2xl p-8 hover:border-accent/50 transition-all duration-300 hover:shadow-elevation-3 animate-fade-in-up"
              style={{ animationDelay: `${index * 0.15}s` }}
            >
              <div className="flex items-start gap-6">
                <div className="w-16 h-16 bg-accent/10 rounded-xl flex items-center justify-center flex-shrink-0 group-hover:bg-accent/20 transition-colors duration-300">
                  <Icon name={highlight.icon} size={32} color="var(--color-accent)" />
                </div>
                <div className="flex-1">
                  <div className="flex items-start justify-between mb-2">
                    <h3 className="text-xl font-bold text-foreground group-hover:text-accent transition-colors duration-300">
                      {highlight.title}
                    </h3>
                    <span className="px-3 py-1 bg-muted text-muted-foreground text-xs font-mono rounded-full">
                      {highlight.year}
                    </span>
                  </div>
                  <p className="text-primary font-medium mb-3">{highlight.institution}</p>
                  <p className="text-muted-foreground leading-relaxed">{highlight.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AcademicHighlights;